import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=0710a42c&"
import script from "./approval.vue?vue&type=script&lang=js&"
export * from "./approval.vue?vue&type=script&lang=js&"
import style0 from "./approval.vue?vue&type=style&index=0&id=0710a42c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0710a42c')) {
      api.createRecord('0710a42c', component.options)
    } else {
      api.reload('0710a42c', component.options)
    }
    module.hot.accept("./approval.vue?vue&type=template&id=0710a42c&", function () {
      api.rerender('0710a42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaves/approval.vue"
export default component.exports